import {
  CREATE_CERTIFICATE_STUDENT,
  CREATE_CERTIFICATE_STUDENT_FAILED,
  CREATE_CERTIFICATE_STUDENT_SUCCESSFUL,
  DELETE_CERTIFICATE_STUDENT,
  DELETE_CERTIFICATE_STUDENT_FAILED,
  DELETE_CERTIFICATE_STUDENT_SUCCESSFUL,
  GET_CERTIFICATE_STUDENT,
  GET_CERTIFICATE_STUDENT_FAILED,
  GET_CERTIFICATE_STUDENT_SUCCESSFUL,
  UPDATE_CERTIFICATE_STUDENT,
  UPDATE_CERTIFICATE_STUDENT_FAILED,
  UPDATE_CERTIFICATE_STUDENT_SUCCESSFUL,
} from '../../../types/masterclass/certificateStudentTypes';

const INIT_STATE = {
  certificateStudents: {
    loading: false,
    error: null,
    data: [],
  },
  createCertificateStudentAction: {
    status: 'idle',
    error: null,
    data: {},
  },
  updateCertificateStudentAction: {
    status: 'idle',
    error: null,
    data: {},
  },
  deleteCertificateStudentAction: {
    status: 'idle',
    error: null,
    data: {},
  },
};

export default (state = INIT_STATE, action) => {
  switch (
    action.type // ------ get_certificate_student ------
  ) {
    case GET_CERTIFICATE_STUDENT:
      return {
        ...state,
        certificateStudents: {
          ...state.certificateStudents,
          loading: true,
          error: null,
        },
      };
    case GET_CERTIFICATE_STUDENT_SUCCESSFUL:
      return {
        ...state,
        certificateStudents: {
          loading: false,
          error: null,
          ...action.payload,
          data: action.payload.data.map((item) => {
            let expiry_date = '';

            if (item?.certificate?.validity_duration_type === 'LIFETIME') {
              expiry_date = 'Lifetime';
            } else {
              const issue_date = new Date(item?.certificate?.issue_date);

              switch (item?.certificate?.validity_duration_type) {
                case 'MONTH':
                  issue_date.setMonth(
                    issue_date.getMonth() +
                      Number(item?.certificate?.validity_duration)
                  );
                  break;

                case 'YEAR':
                  issue_date.setFullYear(
                    issue_date.getFullYear() +
                      Number(item?.certificate?.validity_duration)
                  );
                  break;

                case 'WEEK':
                  issue_date.setDate(
                    issue_date.getDate() +
                      Number(item?.certificate?.validity_duration)
                  );
                  break;

                case 'DAY':
                  issue_date.setDate(
                    issue_date.getDate() +
                      Number(item?.certificate?.validity_duration)
                  );
                  break;

                default:
                  break;
              }

              expiry_date = issue_date.toISOString();
            }

            return {
              ...item,
              issue_date: item?.certificate?.issue_date,
              enrolled_date:
                item?.certificate?.course_basic?.course_enrolled?.find(
                  (student) => student?.user_id === item?.user_id?.id
                )?.created_at,
              expiry_date,
            };
          }),
        },
      };
    case GET_CERTIFICATE_STUDENT_FAILED:
      return {
        ...state,
        certificateStudents: {
          loading: false,
          data: [],
          ...action.payload,
        },
      };
    // ------ create_certificate_student ------
    case CREATE_CERTIFICATE_STUDENT:
      return {
        ...state,
        createCertificateStudentAction: {
          status: 'submitting',
          error: null,
          data: action.payload,
        },
      };
    case CREATE_CERTIFICATE_STUDENT_SUCCESSFUL:
      return {
        ...state,
        createCertificateStudentAction: {
          status: 'submitted',
          error: null,
          data: action.payload,
        },
      };
    case CREATE_CERTIFICATE_STUDENT_FAILED:
      return {
        ...state,
        createCertificateStudentAction: {
          status: 'failed',
          error: action.payload,
          data: {},
        },
      };
    // ------ update_certificate_student ------
    case UPDATE_CERTIFICATE_STUDENT:
      return {
        ...state,
        updateCertificateStudentAction: {
          status: 'submitting',
          error: null,
          data: action.payload,
        },
      };
    case UPDATE_CERTIFICATE_STUDENT_SUCCESSFUL:
      return {
        ...state,
        updateCertificateStudentAction: {
          status: 'submitted',
          error: null,
          data: action.payload,
        },
      };
    case UPDATE_CERTIFICATE_STUDENT_FAILED:
      return {
        ...state,
        updateCertificateStudentAction: {
          status: 'failed',
          error: action.payload,
          data: {},
        },
      };
    // ------ delete_certificate_student ------
    case DELETE_CERTIFICATE_STUDENT:
      return {
        ...state,
        deleteCertificateStudentAction: {
          status: 'submitting',
          error: null,
          data: action.payload,
        },
      };
    case DELETE_CERTIFICATE_STUDENT_SUCCESSFUL:
      return {
        ...state,
        deleteCertificateStudentAction: {
          status: 'submitted',
          error: null,
          data: action.payload,
        },
      };
    case DELETE_CERTIFICATE_STUDENT_FAILED:
      return {
        ...state,
        deleteCertificateStudentAction: {
          status: 'failed',
          error: action.payload,
          data: {},
        },
      };
    default:
      return {
        ...state,
      };
  }
};
